import { FormRouteLeavingPrompt } from '@dreryk/react-components';

import { usePersonalDataFormController } from '../../common/common.hooks';
import { PersonalDataFormController } from '../../common/common.types';
import { selectInitialPersonalData } from '../../common/common.utils';
import { ContactDetailsFormSection } from '../../common/ContactDetailsFormSection';
import { PersonalDataFormSection } from '../../common/PersonalDataFormSection';
import { IdentityDocumentFormSection } from '../../identityDocument/IdentityDocumentFormSection';
import { CreatePatientGuardianTable } from '../CreatePatientGuardianTable';

import { CreatePatientAction } from './CreatePatientAction';
import { StyledCreatePatientPersonalData } from './StyledCreatePatientPersonalData';

export const CreatePatientPersonalData = (): JSX.Element => {
   const {
      register,
      setValue,
      handleSubmit,
      formState,
      watch,
      trigger,
      setError,
      markPristine,
      reset,
      getValues,
   }: PersonalDataFormController = usePersonalDataFormController(selectInitialPersonalData());

   return (
      <StyledCreatePatientPersonalData>
         <PersonalDataFormSection
            register={register}
            watch={watch}
            setValue={setValue}
            setError={setError}
            trigger={trigger}
            reset={reset}
            getValues={getValues}
            formState={formState}
            withGuardians
         />
         <ContactDetailsFormSection register={register} watch={watch} />
         <IdentityDocumentFormSection name={'identityDocument'} register={register} watch={watch} setValue={setValue} />
         <CreatePatientGuardianTable identifyingGuardian={watch('identifyingGuardian')} setValue={setValue} />
         <FormRouteLeavingPrompt formState={formState} />
         <CreatePatientAction handleSubmit={handleSubmit} markPristine={markPristine} />
      </StyledCreatePatientPersonalData>
   );
};
